import axios from 'axios';

const apiOrganizations = {
    projects: {
        get(idToken, organizationId) {
            return axios
                .get(
                    `${process.env.VUE_APP_APIURL}/organizations/${organizationId}/projects`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        }
                    }
                )
                .catch(error => {
                    throw error;
                });
        }
    },
    subscriptions: {
        get(idToken, organizationId) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };

            // fakeApi環境でのテスト用
            if (
                process.env.VUE_APP_ENV === 'local' ||
                process.env.VUE_APP_ENV === 'demo' ||
                process.env.VUE_APP_ENV === 'prototype'
            ) {
                headers['x-api-fake-when-active'] =
                    Math.floor(Math.random() * 2) + 1 === 1 ? true : false;
            }

            return axios
                .get(
                    `${process.env.VUE_APP_APIURL}/organizations/${organizationId}/subscriptions`,
                    {
                        headers: headers
                    }
                )
                .catch(error => {
                    throw error;
                });
        },
        put(params, idToken, organizationId, subscriptionId) {
            let headers = {
                Authorization: 'Bearer ' + idToken,
                'X-From': location.href
            };

            return axios
                .put(
                    `${process.env.VUE_APP_APIURL}/management/organizations/${organizationId}/subscriptions/${subscriptionId}/trial`,
                    params,
                    {
                        headers: headers
                    }
                )
                .catch(error => {
                    throw error;
                });
        }
    },
    users: {
        delete(idToken, organizationId, userId) {
            return axios
                .delete(
                    `${process.env.VUE_APP_APIURL}/organizations/${organizationId}/users/${userId}`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        }
                    }
                )
                .catch(error => {
                    throw error;
                });
        },
        get(idToken, organizationId) {
            return axios
                .get(
                    `${process.env.VUE_APP_APIURL}/organizations/${organizationId}/users`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        }
                    }
                )
                .catch(error => {
                    throw error;
                });
        },
        post(params, idToken, organizationId) {
            return axios
                .post(
                    `${process.env.VUE_APP_APIURL}/organizations/${organizationId}/users`,
                    params,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        }
                    }
                )
                .catch(error => {
                    throw error;
                });
        },
        permissions: {
            organization: {
                delete(idToken, organizationId, userId) {
                    return axios
                        .delete(
                            `${process.env.VUE_APP_APIURL}/organizations/${organizationId}/users/${userId}/permissions/organization`,
                            {
                                headers: {
                                    Authorization: 'Bearer ' + idToken,
                                    'X-From': location.href
                                }
                            }
                        )
                        .catch(error => {
                            throw error;
                        });
                },
                post(idToken, organizationId, userId) {
                    return axios
                        .post(
                            `${process.env.VUE_APP_APIURL}/organizations/${organizationId}/users/${userId}/permissions/organization`,
                            null,
                            {
                                headers: {
                                    Authorization: 'Bearer ' + idToken,
                                    'X-From': location.href
                                }
                            }
                        )
                        .catch(error => {
                            throw error;
                        });
                }
            },
            project: {
                delete(idToken, organizationId, userId, projectId) {
                    return axios
                        .delete(
                            `${process.env.VUE_APP_APIURL}/organizations/${organizationId}/users/${userId}/permissions/project/${projectId}`,
                            {
                                headers: {
                                    Authorization: 'Bearer ' + idToken,
                                    'X-From': location.href
                                }
                            }
                        )
                        .catch(error => {
                            throw error;
                        });
                },
                post(idToken, organizationId, userId, projectId) {
                    return axios
                        .post(
                            `${process.env.VUE_APP_APIURL}/organizations/${organizationId}/users/${userId}/permissions/project/${projectId}`,
                            null,
                            {
                                headers: {
                                    Authorization: 'Bearer ' + idToken,
                                    'X-From': location.href
                                }
                            }
                        )
                        .catch(error => {
                            throw error;
                        });
                }
            }
        }
    }
};
export default apiOrganizations;
